var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartBarVertical01SvgrepoCom14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#C2FAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 11.1458V20.3333M9.125 11.1458H4.63294C4.06122 11.1458 3.77564 11.1458 3.55727 11.2571C3.36519 11.355 3.20914 11.511 3.11126 11.7031C3 11.9215 3 12.2075 3 12.7793V20.3333H9.125M9.125 11.1458V5.63344C9.125 5.06171 9.125 4.77564 9.23626 4.55727C9.33414 4.36519 9.49019 4.20914 9.68227 4.11126C9.90064 4 10.1863 4 10.7579 4H13.6163C14.188 4 14.4745 4 14.6928 4.11126C14.8848 4.20914 15.0405 4.36519 15.1383 4.55727C15.2496 4.77564 15.25 5.06172 15.25 5.63344V8.08333M9.125 20.3333H15.25M15.25 8.08333H19.7417C20.3134 8.08333 20.6001 8.08333 20.8184 8.19459C21.0105 8.29247 21.1655 8.44853 21.2633 8.64061C21.3746 8.85897 21.375 9.14505 21.375 9.71677V20.3334L15.25 20.3333M15.25 8.08333V20.3333",
    stroke: "#1F243B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarVertical01SvgrepoCom14);
export default __webpack_public_path__ + "static/media/chart-bar-vertical-01-svgrepo-com 1 (4).f6f0794f14cf8fe28680929cb0efe527.svg";
export { ForwardRef as ReactComponent };